import React, { useEffect, useState } from 'react';
import { getCategoryCharacteristics } from '../../api/getCategoryCharacteristics';

function CharacteristicsFields({ categoryId, values = {}, onChange }) {
    const [characteristics, setCharacteristics] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!categoryId) {
            setCharacteristics([]);
            return;
        }
        setLoading(true);
        getCategoryCharacteristics(categoryId)
            .then(setCharacteristics)
            .finally(() => setLoading(false));
    }, [categoryId]);

    if (!characteristics.length && !loading) return null;

    const handleChange = (field_label, value) => {
        onChange({ ...values, [field_label]: value });
    };

    return (
        <div className="bg-[var(--background-white-color)] rounded-[10px] p-5 mt-2.5">
            {/* Header */}
            <div className="flex items-center gap-2 mb-4">
                <div className="w-1 h-5 bg-[var(--primary-color)] rounded-full" />
                <h3 className="text-base font-bold text-gray-800 m-0">Сипаттамалар</h3>
            </div>

            {loading ? (
                <div className="flex items-center gap-2 py-3 text-gray-400">
                    <div className="w-4 h-4 border-2 border-[var(--primary-color)] border-t-transparent rounded-full animate-spin" />
                    <span className="text-sm">Жүктелуде...</span>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {characteristics.map((char) => (
                        <div key={char.id} className="flex flex-col gap-1.5">
                            <label className="text-sm font-medium text-gray-600">
                                {char.field_label}
                            </label>
                            <input
                                type="text"
                                className="w-full bg-gray-100 text-gray-800 rounded-lg px-3 py-2.5 border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] focus:border-transparent transition-all"
                                placeholder={char.field_label + ' мәнін енгізіңіз'}
                                value={values[char.field_label] || ''}
                                onChange={(e) => handleChange(char.field_label, e.target.value)}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default CharacteristicsFields;
